import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@rebass/grid";
import { Slide, ToastContainer as ToastContainerBase, toast as toastify, } from "react-toastify";
import { ESpacings } from "../../components";
import { ButtonActions } from "../../components/Button";
import { Icon } from "../../components/Icon";
import * as S from "./Toast.styled";
var variationIconMap = {
    default: "alertDiamond",
    info: "alertDiamond",
    warning: "lightBulb",
    error: "cloudWarning",
    success: "party",
};
var variationClassNameMap = {
    default: "toastify-rentio-default",
    info: "toastify-rentio-info",
    warning: "toastify-rentio-warning",
    error: "toastify-rentio-error",
    success: "toastify-rentio-success",
};
var variationProgressClassNameMap = {
    default: "toastify-default-rentio-default",
    info: "toastify-info-rentio-info",
    warning: "toastify-warning-rentio-warning",
    error: "toastify-error-rentio-error",
    success: "toastify-success-rentio-success",
};
// @deprecated Use `showAlert` instead
export var toast = function (props) {
    var heading = props.heading, content = props.content, action = props.action, customIcon = props.icon, _a = props.autoDismiss, autoDismiss = _a === void 0 ? true : _a, _b = props.variation, variation = _b === void 0 ? "info" : _b, onDismiss = props.onDismiss, navigate = props.navigate;
    var toastId = null;
    var icon = customIcon ? customIcon : variationIconMap[variation];
    var close = function () {
        toastify.dismiss(toastId);
        if (onDismiss) {
            onDismiss();
        }
    };
    var handleActionClick = function () {
        if (action === null || action === void 0 ? void 0 : action.onClick) {
            close();
            action.onClick();
            return;
        }
        if ((action === null || action === void 0 ? void 0 : action.link) && navigate) {
            close();
            // window.open(action.link, "_self");
            navigate(action.link);
        }
    };
    var renderContent = function (_) { return (_jsxs(S.ToastWrap, { children: [_jsx(S.Heading, { children: heading }), content && (_jsx(Box, { mt: ESpacings.extraTight, children: _jsx("div", { children: content }) })), action && (_jsx(Box, { mt: ESpacings.extraTight, children: _jsx(ButtonActions, { actions: [action], options: {
                        overrides: { appearance: "link", onClick: handleActionClick },
                    } }) }))] })); };
    toastId = toastify(renderContent, {
        type: variation,
        closeButton: true,
        icon: icon ? (_jsx(S.Icon, { children: icon && _jsx(Icon, { size: "medium", source: icon }) })) : undefined,
        autoClose: autoDismiss ? 8000 : false,
        closeOnClick: false,
        transition: Slide,
        // customProgressBar: true,
        className: variationClassNameMap[variation],
        progressClassName: variationProgressClassNameMap[variation],
    });
};
export var ToastContainer = function () { return (_jsxs(_Fragment, { children: [_jsx(S.CustomToastStyles, {}), _jsx(ToastContainerBase, { style: { marginTop: "60px", zIndex: 9999999 } })] })); };
